export default "__VITE_ASSET__6986d626__"